module.exports = __webpack_public_path__ + "static/media/millhouse_logo.bfd4af97.png";